import { render, staticRenderFns } from "./ImagesForm.vue?vue&type=template&id=960d6a4c&scoped=true&"
import script from "./ImagesForm.vue?vue&type=script&lang=js&"
export * from "./ImagesForm.vue?vue&type=script&lang=js&"
import style0 from "./ImagesForm.vue?vue&type=style&index=0&id=960d6a4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960d6a4c",
  null
  
)

export default component.exports